export default __webpack_public_path__ + "static/media/strivers_logo_white.ff95177a.png";